import type { KeyboardEvent } from 'react'

import classNames from 'classnames'

import styles from './medicalissues.module.scss'

type IssueListBoxOption = {
  value: number
  label: string
}

type IssueListBoxProps = {
  options: IssueListBoxOption[]
  selectedIds: number[]
  ariaLabel: string
  disabled?: boolean
  onToggle: (id: number) => void
}

export const IssueListBox = ({
  options,
  selectedIds,
  ariaLabel,
  disabled = false,
  onToggle,
}: IssueListBoxProps) => {
  const selected = new Set(selectedIds)

  const handleKeyDown = (event: KeyboardEvent, id: number) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    onToggle(id)
  }

  return (
    <div
      role='listbox'
      aria-multiselectable
      aria-label={ariaLabel}
      aria-disabled={disabled}
      className={classNames(styles.listBox, { [styles.listBoxDisabled]: disabled })}>
      {options.map((option) => (
        <div
          key={option.value}
          role='option'
          aria-selected={selected.has(option.value)}
          tabIndex={disabled ? -1 : 0}
          className={classNames(styles.listBoxOption, {
            [styles.listBoxOptionSelected]: selected.has(option.value),
          })}
          onClick={() => !disabled && onToggle(option.value)}
          onKeyDown={(event) => !disabled && handleKeyDown(event, option.value)}>
          {option.label}
        </div>
      ))}
    </div>
  )
}
